import React from "react";
import heroImg from "../../../assets/banner-12.png";
import gridBanner from "../../../assets/electric-cars-charging-solar-panel-canopy.webp";

const PurePowerGrid = () => {
  return (
    <div>
        <section className="bg-black">
            {/* Hero Section */}
            <div className="relative min-h-screen sm:h-screen bg-cover bg-center flex items-center" style={{ backgroundImage: `url(${heroImg})` }}>
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/35" />
                {/* Content */}
                <div className="relative z-10 px-4 sm:px-8 md:px-24 max-w-[700px] py-12 sm:py-0">

                    <h1 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold leading-tight">
                        PuREPower <br/>
                        Grid Pioneering<br/>
                        Net Zero Goals
                    </h1>

                    <p className="mt-4 sm:mt-8 text-white text-base sm:text-lg md:text-xl lg:text-3xl leading-relaxed">
                        Advanced energy storage products for a stable and sustainable Indian grid.
                    </p>
                </div>
            </div>
        </section>

        {/* Grid Features Section */}
        <section className="bg-[#ededed] pb-16 sm:pb-20 md:pb-28">
            {/* Floating Card */}
            <div className="max-w-[1200px] mx-auto -mt-16 sm:-mt-24 md:-mt-28 relative z-20 bg-black rounded-xl sm:rounded-2xl lg:rounded-[24px] overflow-hidden shadow-2xl px-4 sm:px-0">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/20">
                    {[
                        {
                        title: "5 MWH",
                        desc: "Massive storage for utilities, factories & smart grids",
                        icon: "⚡",
                        },
                        {
                        title: "Scalable",
                        desc: "Containerised Grid Products scalable to meet future demands",
                        icon: "⚙️",
                        },
                        {
                        title: "100% Grid Stability",
                        desc: "Reliable power delivery to ensure grid stability and reduce outages",
                        icon: "☀️",
                        },
                    ].map((item, index) => (

                        <div key={index} className="px-4 sm:px-8 md:px-10 py-8 sm:py-10 md:py-16 text-center">
                            <div className="text-3xl sm:text-5xl md:text-[50px] mb-4 sm:mb-6">
                                {item.icon}
                            </div>
                            <h3 className="text-white text-xl sm:text-2xl md:text-[34px] font-semibold">
                                {item.title}
                            </h3>
                            <p className="mt-3 sm:mt-4 md:mt-6 text-sm sm:text-lg md:text-[22px] text-gray-300 leading-relaxed md:leading-[1.8]">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>

        {/* Banner Image Section */}
        <section className="bg-[#ededed] pb-12 sm:pb-16 md:pb-28">
            <div className="max-w-[1500px] mx-auto px-4 sm:px-6">
                <div className="rounded-2xl sm:rounded-3xl lg:rounded-[32px] overflow-hidden relative">
                    <img src={gridBanner} alt="PuREPower Grid" className="w-full h-[300px] sm:h-[500px] md:h-[750px] object-cover" />
                </div>
            </div>
        </section>
                
        {/* Why PuREPower Grid Section */}
        <section className="bg-[#f4f4f4] py-12 sm:py-16 md:py-28 px-4 sm:px-6">
            <div className="max-w-[1450px] mx-auto">
                <h2 className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-semibold text-[#1B2230]">
                    Why PuREPower Grid
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mt-12 sm:mt-16 md:mt-20">
                    {[
                        {
                        no: "01",
                        title: "Integrated Solution",
                        desc:
                            "A one stop energy storage product for Grid scale and Utility scale solutions ensuring seamless integration and peak performance.",
                        },
                        {
                        no: "02",
                        title: "Scalable by Design",
                        desc:
                            "PuREPower Grid is designed for ever increasing power requirements with industry leading scalability, reliability and safety.",
                        },
                        {
                        no: "03",
                        title: "Safe by Design",
                        desc:
                            "PuREPower Grid delivers unwavering performance even in extreme conditions and exceeds safety standards for continuous power delivery.",
                        },
                    ].map((item) => (
                        <div key={item.no} className="bg-white rounded-2xl sm:rounded-3xl lg:rounded-[32px] p-8 sm:p-10 md:p-12 shadow-lg hover:-translate-y-2 transition duration-500">
                            {/* Number */}
                            <div className="w-16 sm:w-20 md:w-[90px] h-16 sm:h-20 md:h-[90px] rounded-full bg-[#F5B13C] flex items-center justify-center text-xl sm:text-2xl md:text-[30px] font-bold text-black">
                                {item.no}
                            </div>

                            {/* Title */}
                            <h3 className="mt-6 sm:mt-8 md:mt-10 text-xl sm:text-2xl md:text-3xl lg:text-[34px] font-semibold text-[#1B2230] leading-tight">
                                {item.title}
                            </h3>

                            {/* Description */}
                            <p className="mt-4 sm:mt-6 md:mt-8 text-sm sm:text-base md:text-lg lg:text-[20px] leading-relaxed md:leading-[1.9] text-[#4a4a4a]">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    </div>
  );
};

export default PurePowerGrid;
